import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogoMark } from "./Logo";

export const FullLoader = () => (
  <div data-testid="page-loader" className="min-h-screen grid place-items-center">
    <LogoMark className="w-14 h-14 animate-pulse" />
  </div>
);

export function RequireAuth({ children, tier = false, admin = false }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <FullLoader />;
  if (!user) return <Navigate to={`/auth?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/feed" replace />;
  if (tier && !user.tier && user.role !== "admin") return <Navigate to="/join" replace />;
  return children;
}
